/**
 * Asset Manager panel - asset tree, layers, save. Has data processing.
 */
import { AssetManagerTreeView } from "../AssetManagerTreeView";
import { BasePanel } from "./BasePanel";
import type { PanelContainer } from "./BasePanel";

export class AssetManagerPanel extends BasePanel {
    private _container: ReturnType<typeof window.jQuery> | null = null;

    private _treeView: AssetManagerTreeView | null = null;

    getId(): string {
        return "asset-manager";
    }

    getContainer(): PanelContainer {
        if (!this._container) {
            this._container = window.jQuery("#construkted-popup-asset-manager");
        }

        return this._container;
    }

    protected onInit(): void {
        this._treeView = new AssetManagerTreeView("#project-asset-list");
    }

    hasUnsavedChanges(): boolean {
        const saveBtn = window.jQuery("#project-asset-list .save-layer-btn");

        return saveBtn.length > 0 && !saveBtn.hasClass("hidden");
    }

    confirmDiscardChanges(): boolean {
        return window.confirm("You have unsaved changes. Are you sure you want to leave?");
    }
}
